// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2UyIx","placeholdersHeader":"styles_placeholdersHeader__Cs5mM","editorStyle":"styles_editorStyle__22L97","placeholdersBox":"styles_placeholdersBox__1SmR5"};